module.exports = __webpack_public_path__ + "ab48d876869a0fca3cf228ce5d223331.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/profile-action-buttons.png
// module id = 1751
// module chunks = 0